(function () {
  'use strict';

  var module = angular.module('uwAgenda.agenda');
  module.controller('AgendaListsUnconfirmedController', [    
    '$rootScope',
    'SharedAgendaService',
    'AgendaFilterBroadcast',
    'AgendaOverviewService',    
    AgendaListsUnconfirmedControllerFn,
  ]);

  /* controller for agenda list - unconfirmed */
  function AgendaListsUnconfirmedControllerFn(    
    $rootScope,
    SharedAgendaService,
    AgendaFilterBroadcast,
    AgendaOverviewService
  ) {
    var vm = this;

    // list of all shared-agendas for filter
    vm.sharedAgendas = [];
    // list of selected agendas for request the appointments
    vm.selectedAgendas = [];

    // show or hide filter
    vm.showFilter = true;

    /* clear filter */
    vm.clear = clear;

    activate();

    // reload
    vm.reload = function () {
      selectAgendas();
    };

    /* activation work */
    function activate() {
      
      // allow shared agenda-switch
      SharedAgendaService.allow();

      vm.sharedAgendas = SharedAgendaService.getAgendasShownInNewAppointments();

      vm.showFilter = vm.sharedAgendas.length > 1;

      // set default filter
      clear(true); // load filter from localstorage

      //select the agendas for requesting
      selectAgendas();
    } // activate

    //select the agendas for requesting
    function selectAgendas() {
      // get selected agenda ids
      vm.selectedAgendas = [];
      for (var i = 0; i < vm.sharedAgendas.length; i++) {
        if (vm.sharedAgendas[i].vmSelected === true) {
          vm.selectedAgendas.push(vm.sharedAgendas[i]);
        }
      }
    }

    // clear
    function clear(loadFromLocalStorage) {
      // reset selected agendas
      for (var i = 0; i < vm.sharedAgendas.length; i++) {
        vm.sharedAgendas[i].vmSelected = true;
      }

      // inform listener
      $rootScope.$broadcast(AgendaFilterBroadcast.SharedAgendaRefresh);
    }
  }
})();
